// Import legacy polyfills not provided by babel-polyfill.
import 'whatwg-fetch';

// Import the main entry file after the polyfills.
import './main.js';
